import * as React from "react";
import { ITransaction } from "./ITransaction";
import { getFee } from "./getFee";

export function Fee({
  baseCurrency,
  transaction,
}: {
  baseCurrency: string;
  transaction: ITransaction;
}) {
  const fee = getFee(transaction);
  const label = typeof fee === "number" ? fee.toLocaleString() : String(fee ?? "—");
  return (
    <dl className="kv">
      <dt>Fee</dt>
      <dd>
        {label} {baseCurrency || "TLS"}
      </dd>
    </dl>
  );
}
